module.exports = __webpack_public_path__ + "img/universidad_san_carlos.ca4d0009.png";